import { Serializable } from '@core/models';
import { Profitability } from '@optimizer/models';
import { SectionEngineeringProfitability } from './sectionEngineeringProfitability';

export class MenuEngineeringProfitability extends Serializable {
  constructor(menuGuid, maxMultiplier, minMultiplier, units, sectionProfitabilityList) {
    super();
    this.menuGuid = menuGuid || null;
    this.maxMultiplier = maxMultiplier || 1.25;
    this.minMultiplier = minMultiplier || 0.75;
    this.units = units || '%';
    this.sectionProfitabilityList = sectionProfitabilityList || [];
  }

  static toInstance(props = {}) {
    const sectionProfitabilityList = SectionEngineeringProfitability.toInstanceList(props.section_profitability_list);
    return new MenuEngineeringProfitability(props.menu_guid, props.max_multiplier, props.min_multiplier, props.units, sectionProfitabilityList);
  }

  get profitability() {
    let allCurrent = 0;
    let allExpected = 0;
    this.sectionProfitabilityList.forEach((section) => {
      allCurrent += section.currentProfitability;
      allExpected += section.expectedProfitability;
    });
    let profitability = 0;
    if (allCurrent !== 0) profitability = (allExpected - allCurrent) / allCurrent;
    return new Profitability({
      profitability,
      max_profitability: profitability * this.maxMultiplier,
      min_profitability: profitability * this.minMultiplier,
      units: this.units,
      valid: true
    });
  }

  getSectionProfitability(sectionGuid) {
    return this.sectionProfitabilityList.find((s) => s.sectionGuid === sectionGuid);
  }

  getSectionProfitabilities(sectionGuids = []) {
    return this.sectionProfitabilityList.filter((s) => sectionGuids.includes(s.sectionGuid));
  }

  updateSectionProfitability(updatedSectionProfitability, sectionGuid) {
    const index = this.sectionProfitabilityList.findIndex((s) => (s.sectionGuid === sectionGuid));
    this.sectionProfitabilityList.splice(index, 1, updatedSectionProfitability);
  }
}
